import apiClient from '@/services/api';
import type { EventProperties } from '@/types/analytics';
import { ANALYTICS_EVENT_PATH } from './constants';

export const useAnalyticsApi = () => {
  // Send analytics event to backend
  // Fire-and-forget: logs errors but doesn't retry
  const trackAnalyticsEvent = async (
    event: string,
    properties: EventProperties
  ): Promise<void> => {
    try {
      await apiClient.post<void>(ANALYTICS_EVENT_PATH, {
        event,
        properties
      });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Unknown error';
      console.warn('[Analytics] Failed to track event:', event, message);
    }
  };

  return { trackAnalyticsEvent };
};
